import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import isString from "lodash/isString";
import isSymbol from "lodash/isSymbol";
import isFunction from "lodash/isFunction";
import warning from "./warning";
import getDisplayName from "./getDisplayName";
import getConstructorName from "./getConstructorName";
var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    _defineProperty(this, "_topEmitter", null);
    _defineProperty(this, "_parentEmitter", null);
    _defineProperty(this, "_emitters", new Map());
    _defineProperty(this, "_listeners", Object.create(null));
    _defineProperty(this, "_maxListeners", EventEmitter.DEFAULT_MAX_LISTENERS);
  }
  _createClass(EventEmitter, [{
    key: "_checkEventName",
    value: function _checkEventName(name) {
      if (this._topEmitter) {
        this._topEmitter._checkEventName(name);
      } else {
        if (!isString(name) && !isSymbol(name)) {
          throw new TypeError("Event name must be a string or a symbol. Received: ".concat(_typeof(name), "."));
        }
        if (name === "") {
          throw new TypeError("Event name can not be an empty string.");
        }
      }
    }
  }, {
    key: "_checkEventListener",
    value: function _checkEventListener(listener) {
      if (this._topEmitter) {
        this._topEmitter._checkEventListener(listener);
      } else {
        if (!isFunction(listener)) {
          throw new TypeError("Event listener must be a function. Received: ".concat(_typeof(listener), "."));
        }
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      if (this._parentEmitter) {
        var emitters = this._parentEmitter._emitters;
        if (!emitters.has(this._forKey)) {
          emitters.set(this._forKey, this);
        }
        this._parentEmitter._attach();
      }
    }
  }, {
    key: "_prune",
    value: function _prune() {
      if (this._parentEmitter) {
        if (!this._emitters.size && !this.getListenersCount()) {
          this._parentEmitter._emitters["delete"](this._forKey);
          this._parentEmitter._prune();
        }
      }
    }
  }, {
    key: "getMaxListeners",
    value: function getMaxListeners() {
      if (this._topEmitter) {
        return this._topEmitter._maxListeners;
      } else {
        return this._maxListeners;
      }
    }
  }, {
    key: "setMaxListeners",
    value: function setMaxListeners(count) {
      if (this._topEmitter) {
        this._topEmitter.setMaxListeners(count);
      } else {
        this._maxListeners = count;
      }
      return this;
    }
  }, {
    key: "for",
    value: function _for(key) {
      var emitter = this._emitters.get(key);
      if (!emitter) {
        emitter = new EventEmitter();
        emitter._forKey = key;
        emitter._topEmitter = this._topEmitter || this;
        emitter._parentEmitter = this;
      }
      return emitter;
    }
  }, {
    key: "on",
    value: function on(name, listener) {
      this._checkEventName(name);
      this._checkEventListener(listener);
      var listeners = this._listeners[name];
      if (listeners) {
        listeners.push(listener);
      } else {
        listeners = this._listeners[name] = [listener];
      }
      if (process.env.NODE_ENV !== "production") {
        var maxListeners = this.getMaxListeners();
        var forKeys = [];
        var current = this;
        while (current._parentEmitter) {
          forKeys.unshift(current._forKey);
          current = current._parentEmitter;
        }
        var forMessage = "";
        if (forKeys.length) {
          forMessage = forKeys.map(getDisplayName).join(" > ");
        }
        if (forMessage) {
          forMessage = " for `".concat(forMessage, "`");
        }
        warning.once(listeners.length > maxListeners, "Listened to more than {maxListeners} `{name}` events{forMessage}, which may lead to memory leaks.", {
          scope: getConstructorName(this._topEmitter || this),
          variables: {
            name: name,
            maxListeners: maxListeners,
            forMessage: forMessage
          }
        });
      }
      this._attach();
      return this;
    }
  }, {
    key: "once",
    value: function once(name, listener) {
      var _this = this;
      this._checkEventName(name);
      this._checkEventListener(listener);
      var wrapper = function wrapper() {
        _this.off(name, wrapper.__RAW_LISTENER__);
        wrapper.__RAW_LISTENER__.apply(wrapper, arguments);
      };
      wrapper.__RAW_LISTENER__ = listener;
      this.on(name, wrapper);
      return this;
    }
  }, {
    key: "off",
    value: function off(name, listener) {
      this._checkEventName(name);
      this._checkEventListener(listener);
      var listeners = this._listeners[name];
      if (listeners) {
        var position = -1;
        for (var i = listeners.length - 1; i >= 0; i--) {
          if (listeners[i] === listener || listeners[i].__RAW_LISTENER__ === listener) {
            position = i;
            break;
          }
        }
        if (position >= 0) {
          listeners.splice(position, 1);
        }
        if (listeners.length === 0) {
          delete this._listeners[name];
        }
      }
      this._prune();
      return this;
    }
  }, {
    key: "emit",
    value: function emit(name) {
      this._checkEventName(name);
      var listeners = this._listeners[name];
      if (listeners) {
        listeners = _toConsumableArray(listeners);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        for (var i = 0; i < listeners.length; i++) {
          try {
            var _listeners;
            (_listeners = listeners)[i].apply(_listeners, args);
          } catch (error) {
            console.error(error);
          }
        }
      }
      return this;
    }
  }, {
    key: "getEventNames",
    value: function getEventNames() {
      return [].concat(_toConsumableArray(Object.getOwnPropertyNames(this._listeners)), _toConsumableArray(Object.getOwnPropertySymbols(this._listeners)));
    }
  }, {
    key: "getListeners",
    value: function getListeners(name) {
      this._checkEventName(name);
      return (this._listeners[name] || []).map(function (listener) {
        return listener.__RAW_LISTENER__ || listener;
      });
    }
  }, {
    key: "getListenersCount",
    value: function getListenersCount(name) {
      var _this2 = this;
      var sum = 0;
      if (name !== undefined) {
        var _this$_listeners$name;
        this._checkEventName(name);
        sum = ((_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 ? void 0 : _this$_listeners$name.length) || 0;
      } else {
        this.getEventNames().forEach(function (name) {
          var _this2$_listeners$nam;
          sum += ((_this2$_listeners$nam = _this2._listeners[name]) === null || _this2$_listeners$nam === void 0 ? void 0 : _this2$_listeners$nam.length) || 0;
        });
      }
      return sum;
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(name) {
      if (name !== undefined) {
        this._checkEventName(name);
        delete this._listeners[name];
      } else {
        this._listeners = Object.create(null);
      }
      this._prune();
      return this;
    }
  }]);
  return EventEmitter;
}();
_defineProperty(EventEmitter, "DEFAULT_MAX_LISTENERS", 100);
export default EventEmitter;